import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
  }

  optimized(event) {
    const {pageId} = event.target.dataset;

    fetch("/admin/articles/" + pageId, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        is_translation_proofread: true,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        const button = event.target;
        button.classList.remove('btn-danger');
        button.classList.add("btn-success");
      });
  }
}
